import { GENDERS } from '@hfc/common/src/types/Genders';
import { MEMBER_TYPES } from '@hfc/common/src/types/MemberTypes';

export class Person {

  public type: MEMBER_TYPES;
  public gender: GENDERS;
  public date_of_birth?: number;
  public applying: boolean;
  public original_index: number;

  public constructor (type: MEMBER_TYPES, index: number) {
    this.type = type;
    this.gender = '' as unknown as GENDERS;
    this.applying = true;
    this.original_index = index;
  }

}
